import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus,
    homeList,
} from "../../../../../../services/adapters/kepegawaian/homeService"
import { 
    perjalananDinasDetail,
    perjalananDinasApproval, 
    masterRegion,
    partisipanList,
    perjalananDinasDetailCancel
} from '../../../../../../services/adapters/kepegawaian/perjalananDinasService'


class IndexRepository {

    fetchEmployeeList = async (query) => {
        return await apiRequest("get", partisipanList, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", perjalananDinasDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
   
    fetchDetailCancel = async (query, cancelToken) => {
        return await apiRequest("get", perjalananDinasDetailCancel, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchApproval = async (query, cancelToken) => {
        return await apiRequest("post", perjalananDinasApproval, {
            body: query
        }, true)
    }

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }


    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }


}

export default IndexRepository